import SideNav from '@/components/template/SideNav'
import Header from '@/components/template/Header'
import SideNavToggle from '@/components/template/SideNavToggle'
import MobileNav from '@/components/template/MobileNav'
import UserProfileDropdown from '@/custolink-components/layout/UserProfileDropdown'
import SidePanel from '@/components/template/SidePanel'
import LayoutBase from '@/components/template/LayoutBase'
import useResponsive from '@/utils/hooks/useResponsive'
import { LAYOUT_COLLAPSIBLE_SIDE } from '@/constants/theme.constant'
import type { CommonProps } from '@/@types/common'
import Notification from '@/custolink-components/navigation/Notification/Notification'
import IncomingVideoSupport from "@/custolink-components/navigation/IncomingVideoSupport";

const CollapsibleSide = ({ children }: CommonProps) => {
  const { larger, smaller } = useResponsive()

  return (
    <LayoutBase
      type={LAYOUT_COLLAPSIBLE_SIDE}
      className="app-layout-collapsible-side flex flex-auto flex-col"
    >
      <div className="flex flex-auto min-w-0">
        {larger.lg && <SideNav />}
        <div className="flex flex-col flex-auto min-h-screen min-w-0 relative w-full">
          <Header
            className="shadow dark:shadow-2xl"
            headerStart={
              <>
                {smaller.lg && <MobileNav />}
                {larger.lg && <SideNavToggle />}
                { // <Search />
                }
              </>
            }
            headerEnd={
              <>
                { // <LanguageSelector/> <Notification />
                   }


                <IncomingVideoSupport />
                <Notification />
                <UserProfileDropdown hoverable={false} />
              </>
            }
          />
          <div className="h-full flex flex-auto flex-col">
            {children}
          </div>
        </div>
      </div>
    </LayoutBase>
  )
}

export default CollapsibleSide
